import * as React from 'react'
import { ComponentExt } from '@utils/reactExt'
import * as styles from './style/index.scss'
import { Button } from 'antd-mobile'
import { countTotalFlowData, enumToView, filterFlowUnit, formatDate } from '@src/utils'
import { FormattedMessage, FormattedPlural } from 'react-intl'
import intl from '@utils/intl'
import MultiActivity from '@utils/multiActivity'
import { userStore } from '@src/store/userStore'
import { TRYBUY_EVENT_TRACING_CLICK } from '@src/constants'
import lableIcon from '@assets/img/global/lable.png'
interface PackageItemProps {
    type: '0' | '1'   // 套餐类型 0 基础套餐 1 加油包
    dto?: any           // 套餐实体
    goToPackageDetail: (options: any) => void
}

const nameBg = {
    0: '#1B334C',
    1: '#6E3C0F'
}

class PackageItemG extends ComponentExt<PackageItemProps> {
    constructor(props) {
        super(props)
    }

    doOrder = (goodsReleaseId, goodsType, cargoType, activityPlan) => {
        this.props.goToPackageDetail({ goodsReleaseId, goodsType, cargoType, activityPlan })
        const obj = {
            '0': `${filterFlowUnit(this.props.dto.policyDegree)}-${this.props.dto.timeLength}${this.props.dto.timeUnit === '1' ? '天' : '月'}`, // 基础包
            '1': filterFlowUnit(this.props.dto.policyDegree), // 加油包
        }
        userStore.sendEventTracing({
            pageCode: '',
            buttonCode: TRYBUY_EVENT_TRACING_CLICK[this.props.type === '0' ? 'TRYBUY_CLICK_BASE_PACKAGE' : 'TRYBUY_CLICK_ADD_PACKAGE'],
            buttonInfo: obj[this.props.type]
        })
    }

    render() {
        const {
            policyDegree, cargoType, goodsNumber, goodsReleaseName, validTime, totalPrice, goodsReleaseId, activityPlan
        } = this.props.dto
        const multiActivity = new MultiActivity(this.props.dto)
        const unit = multiActivity.formatPackageValidDate().unit
        const goodsTime = multiActivity.formatPackageValidDate().goodsTime
        // 单数
        const odd = intl.formatMessage({ id: `common.${unit === '0' ? 'unitMonthOdd' : 'unitDayOdd'}` })
        // 复数
        const plural = intl.formatMessage({ id: `common.${unit === '0' ? 'unitMonthPlural' : 'unitDayPlural'}` })
        const preMonth = intl.formatMessage({ id: 'common.unitMonthOdd' })
        return (
            <div className={styles.packageItemWrap}>
                <div
                    className={styles.packageName}
                    style={{ backgroundColor: nameBg[multiActivity.hasEffectiveActivity() ? '1' : '0'] }}
                >{goodsReleaseName}
                </div>
                {multiActivity.hasEffectiveActivity() && <>
                    <div className={styles.actTagText}>
                        <span>{intl.formatMessage({ id: 'common.label' })}</span>
                        <img src={lableIcon} />
                    </div>
                </>}
                <div className={`${styles.packageInfoWrap} ${styles[multiActivity.hasEffectiveActivity() ? 'giftBgColor' : '']}`}>
                    <p className={styles.packageContent}>
                        {this.props.type === '1' && <><FormattedMessage id="package.expand.add" />&nbsp;</>}
                        {countTotalFlowData({ goodsNumber, policyDegree })}
                    </p>
                    {
                        this.props.type === '1' ?
                            <span className={styles.validTime}>
                                <FormattedMessage
                                    id="package.validTo"
                                    values={{
                                        date: formatDate(validTime)
                                    }}
                                />
                            </span>
                            :
                            <p className={styles.validTime}>
                                <FormattedMessage
                                    id="package.validDate"
                                    values={{
                                        timeLength: goodsTime,
                                        dateUnit: <FormattedPlural value={goodsTime} one={odd} other={plural} />
                                    }}
                                />
                                {
                                    unit === '0' && goodsTime > 1 &&
                                    <span style={{ marginLeft: 30 }}>{filterFlowUnit(policyDegree)}/{preMonth}</span>
                                }
                            </p>
                    }
                    <div className={styles.price}>
                        <p>{enumToView('CURRENCY', cargoType)}<span style={{ fontSize: 24 }}>{multiActivity.getPriceForShow()}</span></p>
                        {multiActivity.showOldPrice() && <p className={styles.oldPrice}>{enumToView('CURRENCY', cargoType)}<span>{multiActivity.getOldPrice()}</span></p>}
                    </div>
                    <Button
                        className={styles.orderBtn}
                        onClick={() => this.doOrder(goodsReleaseId, this.props.type, cargoType, activityPlan)}
                    >
                        <FormattedMessage id="package.orderBtnText" />
                    </Button>
                </div>
            </div>
        )
    }
}

export default PackageItemG
